import {
  EHeadingStyleVariant,
  ELinkVariant,
  ETextStyleVariant,
  Heading,
  Link,
  Text,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';

import css from './SeasonalGuideSectionReadingList.module.css';
import { TSeasonalGuideSectionReadingList } from './types';

type TSeasonalGuideSectionReadingListProps = {
  readingList: TSeasonalGuideSectionReadingList;
};

export const SeasonalGuideSectionReadingList = ({
  readingList,
}: TSeasonalGuideSectionReadingListProps) => {
  return (
    <MaxWidth className="mx-auto" style={{ marginBottom: readingList.marginBottom }}>
      <div className={cn('text-center px-6 py-4 border border-gray-900 uppercase', css.header)}>
        {readingList.title}
      </div>

      <div className={`grid md:grid-cols-${readingList.items.length}`}>
        {readingList.items.map((item, index) => {
          return (
            <div
              key={index}
              className={cn(
                'px-6 py-4 border border-t-0 border-gray-900 flex flex-col gap-y-4',
                { 'md:border-l-0': index > 0 },
                css.cell,
              )}>
              <Heading variant={EHeadingStyleVariant.H6} component="div">
                {item.title}
              </Heading>

              <Link
                target="_blank"
                rel="noreferrer"
                href={item.url}
                variant={ELinkVariant.Underline}
                style={{ color: '#13A861' }}>
                <Text variant={ETextStyleVariant.MediumBold} style={{ color: '#13A861' }}>
                  {item.linkText}
                </Text>
              </Link>
            </div>
          );
        })}
      </div>
    </MaxWidth>
  );
};
